import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) throw new Error("Missing access token");
  return {
    Authorization: `JWT ${token}`,
    "Content-Type": "application/json",
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let message = "Failed to process request.";
    try {
      const data = await response.json();
      message = data.detail || JSON.stringify(data);
    } catch (err) {
      // ignore parse errors
    }
    throw new Error(message);
  }
  return response.json();
};

export const fetchSystemSettings = async () => {
  const resp = await fetch(`${domain}system-settings/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return handleResponse(resp);
};

export const updateSystemSettings = async (payload) => {
  const resp = await fetch(`${domain}system-settings/`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(resp);
};

export const fetchGlobalSystemSettings = async () => {
  const resp = await fetch(`${domain}global-settings/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return handleResponse(resp);
};

export const updateGlobalSystemSettings = async (payload) => {
  const resp = await fetch(`${domain}global-settings/`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(resp);
};
